import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export function LoadingFullScreen() {
  return (
    <Box
      sx={{
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
      }}
    >
      <CircularProgress color="inherit" />
    </Box>
  );
}
